import { t } from "@lingui/macro";
import { Check, ImageSquare } from "@phosphor-icons/react";
import { defaultResumeData } from "@stylingcv/schema";
import { cn } from "@stylingcv/utils";

import { useResumeStore } from "@/client/stores/resume";

// List of available background image identifiers (without extension)
const backgroundImages = Array.from({ length: 14 }, (_, i) => `${i + 1}`);

export const BackgroundSection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const backgroundImage = useResumeStore((state) => {
    try {
      return (
        state.resume.data.metadata.backgroundImage || defaultResumeData.metadata.backgroundImage
      );
    } catch {
      return defaultResumeData.metadata.backgroundImage;
    }
  });

  const updateBackground = (filename: string) => {
    setValue("metadata.backgroundImage", filename);
  };

  const publicPath = "/assets/sidebar-resume-bg/";

  return (
    <section
      id="background"
      className="space-y-4"
    >
      {/* Section Header */}
      <div className="flex items-center gap-3 border-b border-gray-200 pb-5">
        <div className="flex size-10 items-center justify-center rounded-xl bg-gray-100">
          <ImageSquare size={20} className="text-gray-600" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-[#16344c]">{t`Background`}</h3>
          <p className="text-[11px] text-gray-400">{t`Page background`}</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-5">
        <main className="grid grid-cols-3 gap-4">
        {/* Option to clear background */}
        <div
          className={cn(
            "relative flex h-20 cursor-pointer items-center justify-center rounded border-2 transition-all duration-200 hover:border-[#268599]/50",
            backgroundImage === ""
              ? "border-[#268599] bg-[#268599]/10 shadow-lg ring-2 ring-[#268599]/20"
              : "border-gray-200 hover:shadow-md",
          )}
          onClick={() => {
            updateBackground("");
          }}
        >
          <span className="text-sm text-[#16344c]">{t`None`}</span>
          {backgroundImage === "" && (
            <div className="absolute -right-2 -top-2 flex size-6 items-center justify-center rounded-full bg-[#268599] shadow-lg">
              <Check size={12} weight="bold" className="text-white" />
            </div>
          )}
        </div>
        {backgroundImages.map((img) => (
          <div
            key={img}
            className={cn(
              "relative h-20 cursor-pointer overflow-hidden rounded border-2 bg-white transition-all duration-200 hover:border-[#268599]/50",
              backgroundImage === img
                ? "border-[#268599] shadow-lg ring-2 ring-[#268599]/20"
                : "border-gray-200 hover:shadow-md",
            )}
            onClick={() => {
              updateBackground(img);
            }}
          >
            <img src={`${publicPath}/bg${img}.png`} alt={img} className="size-full object-cover" />
            {backgroundImage === img && (
              <>
                {/* Center check icon overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-[#268599]/20 backdrop-blur-[1px]">
                  <div className="flex size-8 items-center justify-center rounded-full bg-[#268599] shadow-lg">
                    <Check size={16} weight="bold" className="text-white" />
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
        </main>
      </div>
    </section>
  );
};
